module.exports = __webpack_public_path__ + "img/no_item_image.026fedc9.jpeg";